import { render } from "./index.vue?vue&type=template&id=fb5f712c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fb5f712c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb5f712c"

export default script